import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Row, Col, Spinner, Modal } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './ProjectDetails.css';

// AMENITIES IMAGES MAPPER
import poolImg from '../../assets/AmenitiesPhotos/Swimming pool.png';
import gymImg from '../../assets/AmenitiesPhotos/Indoor gym.png';
import clubhouseImg from '../../assets/AmenitiesPhotos/Club house.png';
import basketballImg from '../../assets/AmenitiesPhotos/Indoor full-sized basketball cort.png';
import grillImg from '../../assets/AmenitiesPhotos/On premises bar & gril.png';
import maintenanceImg from '../../assets/AmenitiesPhotos/Availabe maintenance.png';
import appliancesImg from '../../assets/AmenitiesPhotos/Fully stocked appliances.png';
import drivewayImg from '../../assets/AmenitiesPhotos/Private driveway.png';
import garageImg from '../../assets/AmenitiesPhotos/Private garage.png';
import neighborhoodImg from '../../assets/AmenitiesPhotos/Safe neighborhood.png';
import weatherImg from '../../assets/AmenitiesPhotos/Warm weather.png';
import backyardImg from '../../assets/AmenitiesPhotos/Large backyard.png';
import hoopImg from '../../assets/AmenitiesPhotos/Full size backetball hoop.png';

import homeImg5 from '../../assets/HomePhotos/homeImg5.png';
import pdImg1 from '../../assets/ProjectDetailsPhotos/pdImg1.jpg'

const amenityIcons = {
  "Swimming pool": poolImg,
  "Indoor gym": gymImg,
  "Club house": clubhouseImg,
  "Indoor full-sized basketball cort": basketballImg,
  "On premises bar & gril": grillImg,
  "Availabe maintenance": maintenanceImg,
  "Fully stocked appliances": appliancesImg,
  "Private driveway": drivewayImg,
  "Private garage": garageImg,
  "Safe neighborhood": neighborhoodImg,
  "Warm weather": weatherImg,
  "Large backyard": backyardImg,
  "Full size backetball hoop": hoopImg
};

const ProjectDetails = () => {
  const { slug } = useParams();
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // State za Lightbox (Pregled preko celog ekrana)
  const [showLightbox, setShowLightbox] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        //const response = await fetch(`http://localhost:5000/api/project/${slug}`);
        const response = await fetch(`/api/project/${slug}`);
        if (response.ok) {
          const data = await response.json();
          setProperty(data);
        }
      } catch (error) { console.error(error); }
      finally { setLoading(false); }
    };
    fetchDetails();
  }, [slug]);

  const openLightbox = (index) => {
    setPhotoIndex(index);
    setShowLightbox(true);
  };

  if (loading) return <div className="text-center py-5"><Spinner animation="border" /></div>;
  if (!property) return <div className="text-center py-5">Property not found.</div>;

  // Helper function for picture location
  //const getImgUrl = (img) => `http://localhost:5000/uploads/${img.replace(/\\/g, '/').replace('uploads/', '')}`;
  const getImgUrl = (img) => `/api/uploads/${img.replace(/\\/g, '/').replace('uploads/', '')}`;

  return (
    <div className="project-details-page">
      <Container className="mt-4">
        {/* --- Booking gallery --- */}
        <div className="booking-gallery">
          {/* Main big picture (Left) */}
          <div className="gallery-main" onClick={() => openLightbox(0)}>
            <img src={getImgUrl(property.images[0])} alt="Main" />
          </div>

          {/* Meddium picture (Right) */}
          <div className="gallery-side">
            {property.images.slice(1, 3).map((img, idx) => (
              <div key={idx} className="gallery-side-item" onClick={() => openLightbox(idx + 1)}>
                <img src={getImgUrl(img)} alt="Side" />
              </div>
            ))}
          </div>

          {/* Lower row with small pictures( Or hidden pictures) */}
          <div className="gallery-bottom">
            {property.images.slice(3, 7).map((img, idx) => (
              <div key={idx} className="gallery-bottom-item" onClick={() => openLightbox(idx + 3)}>
                <img src={getImgUrl(img)} alt="Thumb" />
                {/* If there are more than 7 pictures, we show the number on the last */}
                {idx === 3 && property.images.length > 7 && (
                  <div className="more-photos-overlay">
                    <span>+{property.images.length - 7} photos</span>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Title and location under the gallery */}
        <div className="property-header mt-4 text-start d-flex justify-content-between align-items-center">
          <div>
            <h1 className="fw-bold">{property.title}</h1>
            <p className="text-muted"><i className="bi bi-geo-alt-fill text-primary"></i> {property.location}</p>
          </div>
          {/* BADGE ZA STATUS */}
          <div className={`status-badge-detail ${property.isAvailable ? 'status-available' : 'status-leased'}`}>
            {property.isAvailable ? 'AVAILABLE' : 'LEASED'}
          </div>
        </div>
      </Container>

        <Modal 
            show={showLightbox} 
            onHide={() => setShowLightbox(false)} 
            size="xl" 
            centered 
            className="lightbox-modal"
            >
            {/* Header now holds close button */}
            <Modal.Header closeButton closeVariant="white" className="border-0 shadow-none position-relative">
            </Modal.Header>
            
            <Modal.Body className="p-0">
                <Swiper
                modules={[Navigation, Pagination]}
                navigation
                pagination={{ type: 'fraction' }}
                initialSlide={photoIndex}
                className="lightbox-swiper"
                >
                {property.images.map((img, index) => (
                    <SwiperSlide key={index}>
                    <div className="lightbox-img-container">
                        <img src={getImgUrl(img)} alt="Project View" />
                    </div>
                    </SwiperSlide>
                ))}
                </Swiper>
            </Modal.Body>
        </Modal>

        <div className="full-width-divider mt-4">
          <img src={homeImg5} alt="Decorative Divider" className="divider-img" />
        </div>

        {/* --- Section 2: Amenities --- */}
        <section className="property-amenities-new">
            <Container>
                <div className="text-center mb-5 pt-5">
                <h2 className="amenities-main-title">Amenities</h2>
                </div>
                
                <div className="amenities-grid">
                {property.amenities?.map((item, idx) => (
                    <div key={idx} className="amenity-square-item">
                    <img 
                        src={amenityIcons[item] || '/placeholder-icon.png'} 
                        alt={item} 
                        className="amenity-img-square"
                    />
                    </div>
                ))}
                </div>
            </Container>
        </section>

            {/* Divider after Amenities section */}
        <div className="full-width-divider">
            <img src={homeImg5} alt="Decorative Divider" className="divider-img" />
        </div>

        {/* --- Section 2: Amenities -------------------------------------------------------------- */}

        {/* --- Section 3: Amazing Features with Background --------------------------------------- */}
        <section className="amazing-features-parallax" style={{ backgroundImage: `url(${pdImg1})` }}>
            <div className="features-dark-overlay">
                <Container h-100>
                <Row className="h-100 align-items-center">
                    <Col md={7} lg={6} className="text-start">
                    <div className="features-list-wrapper">
                        <h2 className="features-title-side mb-5">Amazing Features</h2>
                        
                        {property.amazingFeatures?.map((feature, index) => (
                        <div key={index} className="feature-row-item animate-fade-in">
                            <span className="feature-index">{index + 1}.</span>
                            <h3 className="feature-name-text">{feature}</h3>
                        </div>
                        ))}
                    </div>
                    </Col>
                </Row>
                </Container>
            </div>
        </section>

        <div className="full-width-divider">
            <img src={homeImg5} alt="Decorative Divider" className="divider-img" />
        </div>

        {/* --- Section 3: Amazing Features with Background ---------------------------------- */}

        {/* --- Section 4: Description & Rental Button --------------------------------------- */}
        <section className="project-description-section py-5">
        <Container>
            <Row className="justify-content-center">
            <Col lg={8} md={10} className="text-center">
                {/* Title of the section */}
                <h2 className="description-title mb-4">Overview</h2>
                
                {/* Main text - Overview */}
                <div className="description-text mb-5">
                <p>
                    {property.overview}
                </p>
                </div>

                {/* Main button for renting */}
                <div className="rental-action-wrapper py-4">
                  {property.isAvailable ? (
                    <a 
                        href={property.directLink} 
                        target="_blank" 
                        rel="noreferrer" 
                        className="rental-big-btn"
                    >
                        APPLY NOW / RENTAL AVAILABLE
                    </a>
                  ) : (
                    <div className="leased-container">
                      <a 
                        href={property.directLink} 
                        target="_blank" 
                        rel="noreferrer" 
                        className="rental-big-btn leased-btn-active"
                      >
                        VIEW PROPERTY (ALREADY LEASED)
                      </a>
                      <p className="mt-3 text-muted">
                        This unit is currently occupied, but feel free to browse the details for future interest.
                      </p>
                    </div>
                  )}
                </div>
            </Col>
            </Row>
        </Container>
        </section>

        <div className="full-width-divider">
        <img src={homeImg5} alt="Decorative Divider" className="divider-img" />
        </div>
        {/* --- Section 4: Description & Rental Button -------------------------------- */}

        {/* --- Section 5: Dynamic Google Map ----------------------------------------- */}
        <section className="project-map-section w-100">
        <div className="container-fluid p-0">
            <div className="map-wrapper" style={{ width: '100%', height: '450px', overflow: 'hidden' }}>
            {property.googleMaps && property.googleMaps.includes('<iframe') ? (
                <div 
                className="h-100 w-100"
                dangerouslySetInnerHTML={{ 
                    __html: property.googleMaps
                    .replace(/width="\d+"/, 'width="100%"')
                    .replace(/height="\d+"/, 'height="100%"') 
                }} 
                />
            ) : (
                <div className="d-flex align-items-center justify-content-center h-100 bg-light text-muted">
                <p><i className="bi bi-geo-alt me-2"></i>Map location not available.</p>
                </div>
            )}
            </div>
        </div>
        </section>
    </div>
  );
};

export default ProjectDetails;